import { Workspace } from '../../../authz/gen/ai/h2o/workspace/v1/workspace_pb';
import { ensureTrailingSlash } from '../helpers';

interface BreadcrumbItem {
  text: string;
  key: string;
  onClick?: () => void;
}

interface UseBreadcrumbsProps {
  bucketName?: string;
  directoryPath: string;
  activeWorkspace?: Workspace;
  onNavigate?: (path: string) => void;
}

export const useBreadcrumbs = ({ bucketName, directoryPath, activeWorkspace, onNavigate }: UseBreadcrumbsProps) => {
  const buildBreadcrumbs = (): BreadcrumbItem[] => {
    const items: BreadcrumbItem[] = [];

    items.push({
      text: activeWorkspace?.displayName || bucketName || 'Drive',
      key: 'workspace',
      onClick: onNavigate ? () => onNavigate('') : undefined,
    });

    if (directoryPath) {
      const pathParts = directoryPath.split('/').filter(Boolean);
      let buildPath = '';

      pathParts.forEach((part, index) => {
        buildPath += part;
        const isLast = index === pathParts.length - 1;
        const pathForThisItem = ensureTrailingSlash(buildPath);

        items.push({
          text: part,
          key: pathForThisItem,
          onClick:
            isLast || !onNavigate
              ? undefined
              : () => {
                  onNavigate(pathForThisItem);
                },
        });

        buildPath += '/';
      });
    }

    return items;
  };

  return { breadcrumbItems: buildBreadcrumbs() };
};
